import { ViewProps } from 'react-native';
import {
  PositionProps,
  SpaceProps,
  BorderProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  layout,
  position,
  flexbox,
  space,
  color,
  border,
  borderRadius,
  BorderRadiusProps,
} from 'styled-system';

import styled from 'styled-components';

type ViewStyleProps = LayoutProps &
  SpaceProps &
  ColorProps &
  BorderProps &
  FlexboxProps &
  BorderRadiusProps &
  PositionProps;

export const Container = styled.div<ViewProps & ViewStyleProps>`
  display: flex;
  flex-direction: column;
  ${position};
  ${color};
  ${space};
  ${border};
  ${flexbox};
  ${layout};
  ${borderRadius};
`;

export const Fill = styled.div<ViewProps & ViewStyleProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  ${position};
  ${color};
  ${space};
  ${border};
  ${flexbox};
  ${layout};
  ${borderRadius};
`;

export const Row = styled.div<ViewProps & ViewStyleProps>`
  display: flex;
  flex-direction: row !important;
  ${position};
  ${color};
  ${space};
  ${border};
  ${flexbox};
  ${layout};
  ${borderRadius};
`;
